import { MEASUREMENT_UNITS } from "../endpoints";
import api from "../api";

export default {
    index() {
        return api.get(MEASUREMENT_UNITS);
    }
}